import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  searchBar: {
    padding: '20px 24px',
    background: palette.gradients.white,
    display: 'flex',
    marginBottom: '10px',
    borderRadius: '2px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      flexWrap: 'wrap'
    }
  },
  searchField: {
    flexGrow: '1',
    marginRight: '10px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: '40%'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      marginRight: '0',
      marginBottom: '24px'
    }
  },
  filterSelectorSm: {
    width: '180px',
    marginLeft: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      marginTop: '24px',
      marginLeft: '0'
    }
  },
  filterSelectorMd: {
    width: '320px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: '200px'
    }
  },
  filterSelector: {
    [breakpointsFunc.breakpoints.down('lg')]: {
      flexGrow: '1'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%'
    }
  }
});
export default useStyles;